/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import { Constants } from '@salesforce/scv-connector-base';

export default {
  AMC_LOGIN_SUBMIT: 'LOGIN_SUBMIT',
  AMC_SHOW_LOGIN_PAGE: 'SHOW_LOGIN_PAGE',
  AMC_GET_SHOW_LOGIN_PAGE: 'GET_SHOW_LOGIN_PAGE',
  AMC_SET_SHOW_LOGIN_PAGE: 'SET_SHOW_LOGIN_PAGE',
  AMC_AGENT_CONFIG: 'AGENT_CONFIG',
  // AMC_GET_AGENT_CONFIG: 'GET_AGENT_CONFIG',
  // AMC_SET_AGENT_CONFIG: 'SET_AGENT_CONFIG',
  AMC_START_OUTBOUND_CALL: 'START_OUTBOUND_CALL',
  AMC_START_INBOUND_CALL: 'START_INBOUND_CALL',
  AMC_CONNECT_PARTICIPANT: 'CONNECT_PARTICIPANT',
  AMC_REMOVE_PARTICIPANT: 'REMOVE_PARTICIPANT',
  AMC_REMOVE_SUPERVISOR: 'REMOVE_SUPERVISOR',
  AMC_CONNECT_SUPERVISOR: 'CONNECT_SUPERVISOR',
  AMC_CONNECT_CALL: 'CONNECT_CALL',
  AMC_AGENT_HANGUP: 'AGENT_HANGUP',
  AMC_END_CALL: 'END_CALL',
  AMC_HARDPHONE_EVENT: 'HARDPHONE_EVENT',
  AMC_SET_AGENT_STATUS: 'SET_AGENT_STATUS',
  AMC_GET_PHONE_CONTACTS: 'GET_PHONE_CONTACTS',
  AMC_GET_ACTIVE_CALLS: 'GET_ACTIVE_CALLS',
  AMC_ACTIVE_CALLS: 'ACTIVE_CALLS',
  AMC_SOFTPHONE_LOGOUT: 'SOFTPHONE_LOGOUT',
  AMC_CREATE_TRANSCRIPTION: 'SEND_TRANSCRIPTION',
  AMC_INBOUND_CALL_TYPE: 'inbound',
  AMC_MESSAGE_FROM_CONNECTOR: 'MESSAGE_FROM_CONNECTOR',
  AMC_MESSAGE_TO_CONNECTOR: 'MESSAGE_TO_CONNECTOR',
  AMC_SENDER_TYPE: {
    END_USER: 'END_USER',
    HUMAN_AGENT: 'HUMAN_AGENT',
    VIRTUAL_AGENT: 'VIRTUAL_AGENT',
  },
  AMC_PARTICIPANT_TYPE: {
    ...Constants.PARTICIPANT_TYPE,
  },
  AMC_CALL_TYPE: {
    ...Constants.CALL_TYPE,
  },
  AMC_CALL_CONTROL: {
    ACCEPT_CALL: 'ACCEPT_CALL',
    DECLINE_CALL: 'DECLINE_CALL',
    MUTE: 'MUTE',
    HOLD: 'HOLD',
    SWAP_PARTICIPANTS: 'SWAP_PARTICIPANTS',
    ADD_PARTICIPANT: 'ADD_PARTICIPANT',
    CONFERENCE: 'CONFERENCE',
    RECORD: 'RECORD',
  },
  AMC_HANGUP_REASON: {
    PHONE_CALL_ERROR: 'error',
    PHONE_CALL_ENDED: 'ended',
  },
  AMC_SEND_RECORDING: 'SEND_RECORDING',
  AMC_LOGIN_RESULT: 'LOGIN_RESULT',
  AMC_LOGOUT_RESULT: 'LOGOUT_RESULT',
  AMC_CALL_CONNECTED: 'CALL_CONNECTED',
  AMC_THROW_ERROR: 'THROW_ERROR',
  AMC_ERROR: 'ERROR',
  AMC_PARTICIPANT_CONNECTED: 'PARTICIPANT_CONNECTED',
  AMC_PARTICIPANT_REMOVED: 'PARTICIPANT_REMOVED',
  AMC_MESSAGE: 'MESSAGE',
  AMC_REMOTE_CONTROLLER: 'REMOTE_CONTROLLER',
  AMC_AGENT_ERROR_STATUS: {
    DECLINED_BY_AGENT: 'DeclinedByAgent',
    FAILED_TO_CONNECT_AGENT: 'FailedToConnectAgent',
    MISSED_BY_AGENT: 'MissedByAgent',
  },
  AMC_REQUEST_CALLBACK: 'REQUEST_CALLBACK',
  AMC_PUSH_DIALER: 'PUSH_DIALER',
  AMC_PROGRESSIVE_DIALER: 'PROGRESSIVE_DIALER',
  AMC_SEND_AUDIO_STATS: 'SEND_AUDIO_STATS',
};
export const AMC_USER_MESSAGE = {
  CALL_STARTED: 'CALL_STARTED',
  PARTICIPANT_CONNECTED: 'PARTICIPANT_CONNECTED',
};

export enum AMC_EVENT_NAMES {
  INIT = 'init',
  SEND_STUDIO_CONFIGS = 'sendStudioConfigs',
  GET_SALESFORCE_CONFIG = 'getSalesforceConfig',
  INBOUND = 'inbound',
  CONNECTED = 'connected',
  DISCONNECTED = 'disconnected',
  ON_HOLD = 'onHold',
  INITIATED = 'initiated',
  PRESENCE = 'presence',
  ACCEPT = 'accept',
  HANGUP = 'hangup',
  REJECT = 'reject',
  HOLD = 'hold',
  UNHOLD = 'unhold',
  SWAP = 'swap',
  CONFERENCE = 'conference',
  PRESENCE_CHANGE = 'presenceChange',
  DIAL = 'dial',
  ADD_PARTICIPANT = 'addParticipant',
  GET_ACTIVE_CALLS = 'getActiveCalls',
  SET_ACTIVE_CALLS = 'setActiveCalls',
  GET_EXPIRED_CALLS = 'getExpiredCalls',
  SET_EXPIRED_CALLS = 'setExpiredCalls',
  GET_AGENT_CONFIG = 'getAgentConfig',
  SET_AGENT_CONFIG = 'setAgentConfig',
  GET_VOICE_CAPABILITIES = 'getVoiceCapabilities',
  GET_SHARED_CAPABILITIES = 'getSharedCapabilities',
  SET_VOICE_CAPABILITIES = 'setVoiceCapabilities',
  GET_AGENT_STATUS = 'getAgentStatus',
  SET_AGENT_STATUS = 'setAgentStatus',
  GET_PHONE_CONTACTS = 'getPhoneContacts',
  LOGOUT = 'logout',
  LOGIN = 'login',
  SEND_DIGITS = 'sendDigits',
  BLIND_TRANSFER = 'blindTransfer',
  WARM_TRANSFER = 'warmTransfer',
  MUTE = 'mute',
  UNMUTE = 'unmute',
  REMOVE_PARTICIPANT = 'removeParticipant',
  OUTBOUND = 'outbound',
  LOG = 'log',
  CALL_ENDED = 'callEnded',
  SET_OUTBOUND_CALL_ID = 'setOutboundCallId',
  CHECK_INITIAL_AGENT_STATUS = 'checkInitialAgentStatus',
  INITIALIZE_CONNECTOR = 'initializeConnector',
  PUBLISH_EVENT = 'publishEvent',
  CHECK_INITIAL_PRESENCE = 'checkInitialPresence',
  SEND_ERROR_NOTIFICATION = 'sendNotification',
  LOGIN_FRAME_CLOSED = 'loginFrameClosed',
};
